  <template>
  <div>

  <nav v-scroll="handleScroll" class="navbar">
  <div  v-scroll="handleScrollPartFour" class="navbar-phone">
    <div class="container">
       <a href="tel:0634026022">Bel ons: 06-34026022</a> 
    </div>
  </div>

  <div class="container">

    <router-link class="router-link" to="/">
    <img v-scroll="handleScrollPartTwo" id="logo" src="@/assets/Folded_Paper_logo.svg">
    <div class="logo-dot"></div>
    </router-link>

  <div  v-scroll="handleScrollPartThree" class="menu-trigger" @mouseup="menuOpen=!menuOpen">
    
    <p class="font-size-custom-max-18">Menu</p>
    <label class="toggle">
      <input type="checkbox" id="menu" v-model="checkboxValue" />
      <div>
          <div>
              <span></span>
              <span></span>
          </div>
          <svg>
              <use xlink:href="#path"></use>
          </svg>
          <svg>
              <use xlink:href="#path"></use>
          </svg>
      </div>
    </label>
    
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="path">
            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" ></path>
        </symbol>
    </svg>
  </div>
  </div>

  </nav>
  <div class="menu overlay" :class="{'is-open': menuOpen}">
  <div class="menu-bg"></div>
    <div class="fold-container overlay-content">
    <div class="container hero-container">
      <div class="first-content">
        <div class="intro-tekst">
          <div class="navbar-start">
            <router-link to="/" class="navbar-item" @click.native="uncheck">Home</router-link>
            <router-link to="/werk" class="navbar-item" @click.native="uncheck">Werk</router-link>
            <router-link to="/cultuur" class="navbar-item" @click.native="uncheck">Onze cultuur</router-link>
            <router-link to="/werkwijze" class="navbar-item" @click.native="uncheck">Eigen(werk)wijze</router-link>
            <router-link to="/contact" class="navbar-item" @click.native="uncheck">Contact</router-link>
          </div>
        </div>
      </div>

      <div class="case-hightlight-img">
        <div class="intro-animation">
          <div class="animation">
            <lottie :options="headerImages[0].defaultOptions"/>   
            <router-link class="router-link"  @click.native="uncheck" :to="headerImages[headerIndex].link">{{ headerImages[headerIndex].string }}</router-link>
          </div>
        </div>
      </div>
        <div class="contact">
        <a href="tel:0634026022">06-34026022</a><br>
        <a href="mailto:hello@foldedpaper.nl">hello(at)foldedpaper.nl</a>
        <br>
        <p>Molenstraat 35<br>6099 AH, Beegden<br>Nederland</p>
      </div>
    </div>
    
  </div>
  </div>  
  </div>
  </template>

<script>

import Lottie from '@/lottie.vue';
import * as animationAvansHogeschool from '@/assets/cases/avanshogeschool/headeranimatie/avanshogeschool.json';


export default {
    name: 'navbar',
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationAvansHogeschool.default}, background: 'rgba(255,30,61,0.15)', link: '/werk/avans-hogeschool', string:'Bekijk onze brand new case', },
      ],
       menuOpen:false,
       checkboxValue: false,
    }
  },
  components:{
    'lottie': Lottie,
  },

  methods:{
    vhFix: function () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    },
    uncheck(){
      this.checkboxValue = false;
      var element = document.querySelector('body');
          element.classList.remove('noScroll');
    },
    
    handleScroll: function (evt, el,) {
    if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'background-color: white; box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 10px 7px 0 rgba(0, 0, 0, 0.02); transition: 0.3s all; height: 135px'
        )
      } else { 
        el.setAttribute(
          'style',
          'background-color: transparant; height: 140px'
      )} 
    },

    handleScrollPartTwo: function (evt, el) {
        
      if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'margin-top: 22px; transition: 0.3s all;'
        )
      } else { 
        el.setAttribute(
           'style',
          'margin-top: 64px; transition: 0.3s all;'
      )} 
    },
    
    handleScrollPartThree: function (evt, el) {

        if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'top: 22px; transition: 0.3s all;'
        )
      } else { 
        el.setAttribute(
          'style',
          'top: 64px; transition: 0.3s all;'
      )} 
    },

        handleScrollPartFour: function (evt, el) {

        if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'display: block;'
        )
      } else { 
        el.setAttribute(
          'style',
          'display: none;'
      )} 
    },
  },
  mounted(){
    this.vhFix();
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },

    watch:{
      $route (to, from){
        this.menuOpen = false;
      },
       menuOpen: function (menuOpen) {
        if (menuOpen) {
          // document.body.style.overflow = 'hidden'

        setTimeout(() => {
          var element = document.querySelector('body');
          element.classList.add('noScroll');
          document.body.querySelector('#logo').style.pointerEvents = 'none'

        }, 1500)
          
        } else {
          var element = document.querySelector('body');
          element.classList.remove('noScroll');
          document.body.querySelector('#logo').style.pointerEvents = 'all'
        }
      }
    },
  }  
 
</script>

<style scoped lang="scss">
.navbar-phone {
  display: none;
  background: black;
  height: 35px;
  line-height: 35px;
  width: 100%;

    a {
      color: white;
      float: right;
      font-family: $font-stack-copy;
      text-decoration: none;
      font-size: 18px !important;
    }
}

@media screen and (max-width: 640px) {
  body .navbar-phone{
    display: block !important;
  }
  .navbar {
    height: 130px !important;
  }
}


</style>